module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAKJJREFUWEfd17EOhCAQRVHnqylXS76aDZZWzHt3QpSGznscEwlxbF6xuX+8A9B7P+ekWmv3Tq6lCUxARPzGGBeNWALMN65CLAOqEClABSINoBESgETIAAphAQiEDXARCMBBYAAVgQIUxLcAynmBTUCJz0+GANQ4AnDiNsCNWwAiLgOouAQg42kAHU8BKuLLgKp4CrD1YkLehJ7PQn7FDnA74A+5dMghseH+7QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/right_2.png
// module id = M9vz
// module chunks = 1